/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {FlagOutlined, Layers, LocalOffer} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {CATEGORIAS, ESTADOSPRENDA} from "../../Constantes";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoSelectPropId from "../../Modulo_formularios/Componentes/IngresoSelectPropId";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelectFalsoVerdadero from "../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";
import IngresoSelectTextoArray from "../../Modulo_formularios/Componentes/IngresoSelectTextoArray";


const Formulario_Producto = ({...props}) => {
    const [colecciones, setColecciones] = useState([])
    const [tipos, setTipos] = useState([])
    const [etiquetas, setEtiquetas] = useState([])

    useEffect(() => {

        obtenerCol('colecciones').then((dox) => {
            setColecciones(dox.data)
        })

        obtenerCol('subcategorias').then((dox) => {
            setTipos(dox.data)
        })

        obtenerCol('etiquetas').then((dox) => {
            setEtiquetas(dox.data)
        })

    }, [])

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Estado y Coleccion</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'}
                                   dato={'estado'}  {...props}
                                   opciones={ESTADOSPRENDA.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelectPropId Icono={Layers} nombre={'Coleccion'} propiedad={'nombre'} propiedadId={'id'}
                                         dato={'coleccion'} datoId={'idColeccion'}{...props}
                                         opciones={colecciones}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Imagen de la prenda 400px por 600px peso maximo 300kb</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoImagenCrop alto={6} ancho={4}
                                       dato={'img'} {...props}

                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoSelect Icono={Layers} nombre={'Categoria'}
                                   dato={'categoria'} {...props} opciones={CATEGORIAS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Tipo'}
                                   dato={'tipo'} {...props} opciones={tipos.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Layers} nombre={'Nombre de la prenda'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero nombre={'Valor Actual'}
                                   dato={'valor'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={LocalOffer} nombre={'Valor Antes'}
                                   dato={'valorAntes'} {...props}

                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoSelectFalsoVerdadero lineas={5} nombre={'Best Sellers'}
                                                 dato={'masVendido'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectTextoArray nombre={'Etiquetas'}
                                             dato={'etiquetas'} {...props} opciones={etiquetas.map((it) => it.nombre)}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto